<template>
  <div class="">
    <!-- <SkeletonTable v-if="loadBar == true"></SkeletonTable> -->
    <!-- <v-card v-else class="no-shadow"> -->
    <v-card class="no-shadow">
      <v-card-title class="ctn_search">
        Gateways

        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="itemsData"
        :loading="getLoadTable"
        :footer-props="{
          'items-per-page-options': [10],
        }"
        :items-per-page="10"
        :server-items-length="totalNumberOfItems"
        :options.sync="pagination"
        loading-text="Cargando información …."
        :search="search"
      >
        <template v-slot:[`item.activate`]="{ item }">
          <div class="lb lb_activo" v-if="item.activate == 1">Activo</div>
          <div class="lb lb_inactivo" v-else>
            <span class="span_inactive">Inactivo</span>
          </div>
        </template>
        <template v-slot:[`item.nameStation`]="{ item }">
          {{ item.nameStation }}
        </template>
        <template v-slot:[`item.userGateway`]="{ item }">
          {{ item.userGateway }}
        </template>
        <template v-slot:[`item.passwordGateway`]="{ item }">
          <span>{{ getViewEye }}</span>
          <v-btn
            v-if="isMaster == 1"
            class="btn_eye"
            color=""
            @click="viewEye(item.passwordGateway)"
            icon
            x-small
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.city`]="{ item }">
          {{ item.city }}
        </template>
        <template v-slot:[`item.ipRemote`]="{ item }">
          {{ item.ipRemote }}
        </template>
        <template v-slot:[`item.port`]="{ item }">
          {{ item.port }}
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.updateAt | formatDate }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="isMaster == 1"
                class="table_menu"
                color="primary"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item class="list_action">
                <v-btn plain @click="verifyConnection(item)">
                  <span>Verificar conexión</span>
                </v-btn>
              </v-list-item>
              <v-list-item class="list_action">
                <v-btn plain @click="editItem(item)">
                  <span>Editar</span>
                </v-btn>
              </v-list-item>
              <v-list-item class="list_action">
                <v-btn plain @click="deleteItem(item)">
                  <span>Eliminar</span>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <Edit
      :data="itemObjct"
      :visible="EditFlag"
      @close="EditFlag = false"
    ></Edit>
    <Delete
      :data="itemObjct"
      :visible="DeleteFlag"
      @close="DeleteFlag = false"
    ></Delete>
    <v-dialog
      v-model="verifying"
      hide-overlay
      persistent
      width="300"
    >
      <v-card dark>
        <v-card-text>
          <p class="pt-3">Verificando conexión...</p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import Edit from '@/components/station/Edit.vue'
import Delete from '@/components/station/Delete.vue'
export default {
  name: 'StationTableComp',
  components: {
    Edit,
    Delete,
  },
  data() {
    return {
      search: '',
      flagTable: true,
      EditFlag: false,
      DeleteFlag: false,
      eyeFlag: '******',
      itemObjct: {},
      itemsData: [],
      totalItems: 0,
      page: 0,
      verifying: false,
      totalNumberOfItems: 0,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: 'Estado', value: 'activate' },
        {
          text: 'Nombre de Gateways',
          align: 'start',
          sortable: false,
          value: 'nameStation',
        },
        { text: 'Usuario', value: 'userGateway' },
        { text: 'contraseña', value: 'passwordGateway' },
        { text: 'Ciudad', value: 'city' },
        { text: 'IP', value: 'ipRemote' },
        { text: 'Port', value: 'port' },
        { text: 'Creado', value: 'createdAt' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    }
  },
  mounted() {
    this.getJsonData()
    // evento despues de nueva estacion
    this.$root.$on('reload', () => {
      this.getJsonData()
    })
  },
  watch: {
    search: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs
        })
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs
        })
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['listStation','alertSnackbar']),

    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token }
          axios
            .get(
              `station/list?page=${this.pagination.page}&search=${this.search}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.itemsData = res.data.docs
              this.totalNumberOfItems = res.data.totalDocs
              resolve(res.data)
            })
            .catch((error) => {
              reject(error.response.status)
            })
        })
      } catch (error) {
        throw new Error(error.response.data)
      }
    },
    viewEye(param) {
      if (param == this.eyeFlag) {
        this.eyeFlag = '******'
      } else {
        this.eyeFlag = param
      }
    },
    editItem(param) {
      this.itemObjct = Object.assign({}, param)
      this.EditFlag = true
    },
    deleteItem(param) {
      this.itemObjct = Object.assign({}, param)
      this.DeleteFlag = true
    },
    verifyConnection(param) {
      let headerToken = { token: this.$store.state.token }
      this.verifying = true;
      axios.get(
        `station/verify/${param._id}`,
        { headers: headerToken }
      )
      .then(() => {
        this.verifying = false;
        this.alertSnackbar({
          snackbar: true,
          text: "La conexión es exitosa.",
        });
      })
      .catch(() => {
        this.verifying = false;
        this.alertSnackbar({
          snackbar: true,
          text: "Ha fallado la conexión.",
        });
      });
    },
  },
  computed: {
    ...mapGetters(['getListStation', 'isMaster']),
    loadBar() {
      if (this.itemsData.length > 0) {
        return false
      } else {
        return true
      }
    },
    getLoadTable() {
      if (this.itemsData.length > 0) {
        return false
      }
      return true
    },
    getHeader() {
      if (this.isMaster == 1) {
        return this.headerMaster
      }
      return this.headersClient
    },
    getViewEye() {
      return this.eyeFlag
    },
  },
  filters: {
    formatDateShort: (value) => {
      if (value) {
        return moment(value).format('LL')
      }
      return '-'
    },
    formatDate: (value) => {
      if (value) {
        return moment(value)
          .locale('es')
          .format('LLL')
      }
      return '-'
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/base.scss';
.table_menu {
  background-color: hsl(120deg 100% 25% / 4%);
}
.span_inactive {
  color: $alert;
}
.list_action {
  padding: 0 2px;
  &:last-child {
    button:hover,
    a:hover {
      background-color: $alert;
    }
  }
  a,
  button {
    color: $color-text;
    text-decoration: none;
    display: block;
    font-size: 0.9rem;
    padding: 6px 16px;
    border-radius: 2px;
    width: 100%;
    &:hover {
      color: #fff;
      background-color: $color-link;
    }
  }
  span {
    font-size: 0.9rem;
  }
}
.btn_eye {
  color: $dark-jungle-green !important;
  background-color: $color-primary-1 !important;
  margin-left: 10px;
}
</style>
